export let taxListProps = {
    key: 0,
    id: 0,
    tax_id: null,
    tax_percent: 0,
    tax_amount: 0
}

export let dataProps = {
    id: 0,
    store_id: null, 
    home_currency_id: 0,
    currency_id: null,
    exchange_rate: 1,
    journal_date: new Date(),
    additional_notes: '', 
    account_sub_category_id: null,
    expense_by_staff_id: null,
    sub_amount: 0, 
    tax_amount: 0,
    adjustment: 0, 
    net_total: 0, 
    bank_id: null,
    biller_id: 0,
    expense_bill_id: 0,
    
    tax_list: [JSON.parse(JSON.stringify(taxListProps))],
    deleted_tax_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseJournal/properties.js